import React from "react";
import Routes from "./router/routes";
import store from "./redux/store";
// import { Provider } from "react-redux";
import { SidebarProvider } from "./layouts/sidebar/sidebarContext";
import { LicenseInfo } from "@mui/x-license-pro";
import "./app.scss";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { PageLayout } from "./components/pageLayout/PageLayout";
import { Provider } from "react-redux";
import { AppProvider } from "./stateContext/AppContext";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { SnackbarProvider } from "./components/globalSnackNotify/globalSnackNotifyContext";
import { DecisionDialogBoxProvider } from "./components/decisionDialogBox/decisionDialogBoxContext";
import { init} from "@fullstory/browser";

/*
 * The App function is the main component of the application.
 * When it mounts, it fetches data using the fetchData function and caches it
 * under the key "uiValues". If there's an error during fetching, it logs the error.
 * The component then renders the application's routes within the Redux Provider and SidebarProvider components.
//  */


if (process.env.REACT_APP_FULLSTORY_GTM) {
  init({
    orgId: process.env.REACT_APP_FULLSTORY_GTM
  });
}

LicenseInfo.setLicenseKey("6bda9e8b70dbef6b434970a99e43f1faTz05NjA0MCxFPTE3NzU1Nzc2MDAwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=");

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      retryOnMount: false,
      refetchOnReconnect: true
    },
  },
});


const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    (d) => ({
      default: d.ReactQueryDevtools,
    }),
  ),
)

const App: React.FC<{ instance: PublicClientApplication; }> = ({ instance }) => {

  const [showDevtools, setShowDevtools] = React.useState(false)

  React.useEffect(() => {
    // @ts-expect-error
    window.toggleDevtools = () => setShowDevtools((old) => !old)
  }, [])

  return (
    <MsalProvider instance={instance}>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen buttonPosition="top-right" />
        {showDevtools && (
          <React.Suspense fallback={null}>
            <ReactQueryDevtoolsProduction />
          </React.Suspense>
        )}
        <Provider store={store}>
          <AppProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <PageLayout>
                <DecisionDialogBoxProvider>
                  <SnackbarProvider>
                    <SidebarProvider>
                      <Routes />
                    </SidebarProvider>
                  </SnackbarProvider>
                </DecisionDialogBoxProvider>
              </PageLayout>
            </LocalizationProvider>
          </AppProvider>
        </Provider>
      </QueryClientProvider>
    </MsalProvider>
  );
};

export default App;
